export default __webpack_public_path__ + "static/media/GO-OFF.93263457.png";